import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_tariff_details',
};

export const getTariffDetailsRequest = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
